module.exports = __webpack_public_path__ + "img/icon_home03_hover.53df4a2f.png";